jQuery(function($){
  var telLinks = {
    init: function(){
      $('.js-tel-link').on('click', function(e){
        if (window.matchMedia('(min-width: 640px)').matches){
          e.preventDefault();
          $(this).siblings('p.m--hidden').removeClass('m--hidden');
        }
      });
    }
  };
  $(document).ready(telLinks.init);
  window.telLinks = telLinks;
});
